import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import Dashboard from "@/pages/admin/Dashboard";
import MultiDashboard from "@/pages/admin/MultiDashboard";

// Routes /dashboard to the right cockpit: MULTI operators get the central
// multi-location dashboard; everyone else keeps the existing single dashboard.
export default function DashboardEntry() {
  const [mode, setMode] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/org/current").then(({ data }) => {
      if (!alive) return;
      setMode(data.status === "ok" ? (data.tenant.account_mode || "single") : "single");
    }).catch(() => { if (alive) setMode("single"); });
    return () => { alive = false; };
  }, []);

  if (mode === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-fundio-bg" data-testid="dashboard-entry-loading">
        <Loader2 className="animate-spin" style={{ color: "#D89A00" }} />
      </div>
    );
  }
  return mode === "multi" ? <MultiDashboard /> : <Dashboard />;
}
